import { render, staticRenderFns } from "./NeoUploadDragger.vue?vue&type=template&id=a072f7c4&scoped=true&"
import script from "./NeoUploadDragger.vue?vue&type=script&lang=js&"
export * from "./NeoUploadDragger.vue?vue&type=script&lang=js&"
import style0 from "./NeoUploadDragger.vue?vue&type=style&index=0&id=a072f7c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a072f7c4",
  null
  
)

export default component.exports